module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Time-schedule-411388d8dc769f14ac6f305fc8398e59.svg";